import React from 'react';
import PropTypes from 'prop-types';
import {ControlLabel, FormGroup} from 'react-bootstrap';
import HttpRequest from "../../services/HttpRequest";
import Select from 'react-select';
import Notify from "../../services/Notify";
import Objects from "../../utils/Objects";
import Loading from "../Loading/Loading";
import 'react-select/dist/react-select.css';
import './BaseSelector.css';

class BaseSelectorReadonlyToInput extends React.Component {

  httpRequest = new HttpRequest();

  constructor(props, label, value) {
    super(props);
    this.fetchData = this.fetchData.bind(this);

    const {setValue, defaultValue, multiple, mapItems, filterParamName, processData} = props;
    this.state = {label, value, defaultValue: defaultValue};
    this.state.defaultValue = defaultValue;
    this.state.value = 'id';
    this.state.multiple = multiple;
    this.state.mapItems = mapItems;
    this.state.filterParamName = filterParamName || label;
    this.state.processData = processData
    this.state.hide = props.hide

    if (setValue && defaultValue) {
      this.getDefaultValue(defaultValue)
    }

  }

  componentWillMount() {
    const {items, defaultValue, value} = this.state;
    if (Objects.nonEmptyOrBlank(defaultValue)) {
      if (!Objects.isNullOrUndefined(items)) {
        const defaultValueObject = items.filter(x => x[value] === defaultValue)[0];
        this.setState({defaultValue: defaultValueObject});
        return;
      }
      this.setState({loading: false, defaultValue: defaultValue});
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.props.defaultValue) {
      this.setState({defaultValue: nextProps.defaultValue});
    }
  }

  getDefaultValue(defaultValue) {
    if (Array.isArray(defaultValue) || typeof defaultValue !== 'object') {
      this.props.setValue(defaultValue)
    } else {
      this.props.setValue(defaultValue.id)
    }
  }

  handleOnChange = (value) => {
    this.setState({defaultValue: value});
    if (Array.isArray(value)) {
      this.props.setValue && this.props.setValue(value);
      this.props.onChange && this.props.onChange(value);
      return;
    }
    this.props.setValue && this.props.setValue(value && value.id);
    this.props.onChange && this.props.onChange(value);

  };

  render() {
    const {required, readonly = false, multiple, hide, openToTop} = this.props;
    const {title, label, value, defaultValue, loading = false, style} = this.state;

    if (loading) {
      return <Loading/>;
    }

    if (hide) {
      return null
    }

    return (
      <FormGroup className={openToTop && 'select-up'}>
        <ControlLabel>{`${title}${required ? ' *' : ''}`}</ControlLabel>
        <Select.Async multi={multiple}
                      value={defaultValue}
                      disabled={readonly}
                      onChange={this.handleOnChange}
                      valueKey={value}
                      labelKey={label}
                      required={required}
                      placeholder={this.props.placeholder || "-- selecione --"}
                      loadOptions={this.fetchData}
                      style={style}/>
      </FormGroup>
    );
  }

  getUrl(url, label, input) {
    const queryString = `sort=${label},ASC&${label}=${input}`;

    if (url.indexOf('?') >= 0) {
      return url + '&' + queryString;
    }
    return url + '?' + queryString;
  }

  fetchData(input, callback) {
    const {url, items, label, filterParamName, value, mapItems, processData} = this.state;
    const {filterItems} = this.props;

    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    this.timerId = setTimeout(() => {
      if (items) {
        const itemsFiltered = items.filter(
          x => x[label].toLowerCase().indexOf(input.toLowerCase()) >= 0);
        callback(null, {options: itemsFiltered});
        return;
      }

      this.httpRequest.get(this.getUrl(url, (filterParamName || label), input)).then(
        (data) => {
          let options = data["content"] ? data.content : data;

          if (processData) {
            options = processData(options)
          }

          if (filterItems) {
            options = options.filter(filterItems);
          }
          if (mapItems) {
            options = options.map(mapItems);
          }
          const content = options.map(
            item => BaseSelectorReadonlyToInput.mapItems(item, label, value));
          callback(null, {options: content});
        },
        (error) => {
          Notify.error('Falha ao buscar dados: ' + error);
        }
      )
    }, 800);
  }

  static mapItems(item, label = 'name', value = 'id') {
    const obejct = item;
    obejct[value] = item[value];
    obejct[label] = BaseSelectorReadonlyToInput.getLabel(item, label);
    return obejct;
  }

  static getLabel(item, fields) {
    let label = '';
    if (Array.isArray(fields)) {
      let text = [];
      fields.forEach((field) => {
        text.push(BaseSelectorReadonlyToInput.getValueFromLabel(item, field));
      });
      label = text.join(' - ');
    } else {
      label = BaseSelectorReadonlyToInput.getValueFromLabel(item, fields);
    }
    return label;
  }

  static getValueFromLabel(item, field) {
    if (field.indexOf('.') > 0) {
      let value = item;

      field.split('.').forEach(f => {
        value = value[f];
      });
      return value;
    }
    return item[field];
  }

}

BaseSelectorReadonlyToInput.propTypes = {
  url: PropTypes.string,
  items: PropTypes.array,
  name: PropTypes.string,
  title: PropTypes.string.isRequired,
  fieldId: PropTypes.string,
  fieldValue: PropTypes.any,
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.any,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
  filterItems: PropTypes.func,
  mapItems: PropTypes.func,
  multiple: PropTypes.bool
};

export default BaseSelectorReadonlyToInput;



// WEBPACK FOOTER //
// ./src/component/Select/BaseSelectorReadonlyToInput.js